import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchActiveCVEDetailsTotal, addIpVa, fetchRiskTotalFinding } from "../../actions/vulnerability";
import { Link, useParams } from "react-router-dom";
import Pagination from "../Pagination/Pagination";
import { Donut } from "react-dial-knob";
import ScanMessage from "../common/scanningMessage";
import AccessPage from "../Shared/accessPage";
import axios from "axios";
import { toastr } from "react-redux-toastr";
import $ from "jquery";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSortUp, faSortDown } from '@fortawesome/free-solid-svg-icons';


const InfrastructureVA = () => {
  const dispatch = useDispatch();
  const myRef = useRef(null);
  const [filterData, setfilterData] = useState("all");
  const [page, setPage] = useState(1);
  const [search, setsearch] = useState("");
  const [totalItems, setTotalItems] = useState(0);
  const [category, setCategory] = useState("all");
  const [searchName, setSearchName] = useState("");
  const vendorName = sessionStorage.getItem('vendorName');
  const vendorId = sessionStorage.getItem('vendorId');
  const [isModalThree, setModalThree] = useState(false);
  const [Ips, setIps] = useState([]);
  const [sortOrder, setSortOrder] = useState("");

  const { orgId } = useParams();
  const id = useSelector(state => {
    if (orgId) {
      return orgId;
    } else {
      return state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id;
    }
  });

  const client = useSelector(
    (state) => state?.summary?.localClient || state?.summary?.clients?.[0]
  );

  let table = useSelector(
    (state) => state.vulnerability?.riskFinding?.data?.findings
  );

  let totalCount = useSelector((state) => state.vulnerability?.cveTotal?.data);

  const pagination = useSelector(
    (state) => state.vulnerability?.riskFinding?.data
  );

  let scanCompleted = useSelector(
    (state) => state.vulnerability?.scanCompleted
  );

  const executeScroll = (val) => {
    setfilterData(val);
    myRef.current.scrollIntoView();
  };

  const auth = useSelector((state) => state?.auth?.user);


  useEffect(() => {
    fetchRiskTotalFinding(id, dispatch, page, searchName, sortOrder, search);
  }, [id, dispatch, page, searchName, sortOrder, search]);

  useEffect(() => {
    setTotalItems(pagination?.totalFindings);
  }, [pagination?.totalFindings]);

  useEffect(() => {
    fetchActiveCVEDetailsTotal(id, dispatch);
  }, [id, dispatch]);


  const handleSearchChange = (e) => {
    const inputValue = e.target.value;
    clearTimeout(handleSearchChange.timeoutId);
    handleSearchChange.timeoutId = setTimeout(() => {
      setSearchName(inputValue);
      setPage(1);
    }, 1000);
  };

  let mapData = table;

  let currentTableData = [];

  if (mapData && mapData.length > 0) {
    currentTableData = mapData;
  }

  let clientName = "";

  if (JSON.parse(localStorage.getItem("OrgName"))) {
    if (sessionStorage.getItem('vendorId')) {
      clientName = sessionStorage.getItem('vendorName')
    } else {
      clientName = JSON.parse(localStorage.getItem("OrgName"));
    }
  }

  const downloadFile = async () => {
    try {
      const session = localStorage.getItem("session");
      axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
      const response = await axios.get(
        `https://api.brandsek.com/api/organisations/${id}/active-vulnerabilities/scan/excel`,
        {
          responseType: "blob",
        }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${clientName?.replace(/\s+/g, '-')}IP Vulnerability Details.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      // console.error removed
    }
  };

  const severity = (val) => {
    if (val < 4) {
      return "Low";
    }
    if (val >= 4 && val < 7) {
      return "Medium";
    }
    if (val >= 7 && val < 9) {
      return "High";
    }
    if (val >= 9) {
      return "Critical";
    }
  };

  const severityBatch = (val) => {
    if (val < 4) {
      return "badge badge-low";
    }
    if (val >= 4 && val < 7) {
      return "badge badge-med";
    }
    if (val >= 7 && val < 9) {
      return "badge badge-high";
    }
    if (val >= 9) {
      return "badge badge-critical";
    }
  };

  const removeKeyword = (index) => {
    let ip = [...Ips];
    ip.splice(index, 1);
    setIps(ip);
  }

  const addIps = () => {
    let val = $("#ips").val()
    setIps([...Ips, val])
    $("#ips").val('')
  }

  const submitIps = () => {
    if (Ips.length === 0) {
      toastr.error("error", "IP is required to proceed.");
      return;
    }
    let ips = {
      "ipAddresses": Ips
    }
    addIpVa(id, dispatch, ips)
    setModalThree('')
    setIps([])
  }

  const reScan = (ip) => {
    let data = {
      "ipAddresses": [ip]
    }
    addIpVa(id, dispatch, data)
  }
  return (
    <>
      <div className="container-fluid">
        <AccessPage></AccessPage>
        <div className="block-header">
          <div className="row clearfix">
            <div className="col-md-6 col-sm-12">
              <h1 className="welcome-text">Active Vulnerability Assessment </h1>
              <nav aria-label="breadcrumb" className="mt-1">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    {vendorId ? <>
                      <Link to="/vendor"
                        onClick={(() => {
                          sessionStorage.clear();
                        })}
                      >Vendor Assessment</Link>
                    </> : <Link to="/" className="welcome-textSmall">Home</Link>}
                  </li>
                  {
                    vendorName ?
                      <li
                        className="breadcrumb-item active"
                        aria-current="page"
                        style={{ color: "white" }}
                      >
                        <Link to={`/dashboard/vendor/${vendorId}`}
                        >{vendorName}</Link>
                      </li> : ''
                  }
                  <li className="breadcrumb-item active"
                    aria-current="page">
                    Active Vulnerability Assessment
                  </li>
                </ol>
                <br />
              </nav>
              {/* <p>Grade : {riskScore || "Calculating..."}</p> */}
            </div>
            <div className="col-md-6 col-sm-12 text-right hidden-xs d-flex justify-content-end">
              {mapData?.length === 0 ? null : (
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    downloadFile();
                  }}
                  href="/add-report"
                  className="btn btn-sm btn-primary mr-1 download-report"
                >
                  Download Details
                </a>
              )}
            </div>
          </div>
        </div>

        {typeof scanCompleted !== "undefined" && !scanCompleted && (
          <div className="card border-success">
            <ScanMessage />
          </div>
        )}

        <div className="row clearfix">
          <div className="col-lg-12 col-md-8">
            <div className="row">
              <div className="col-lg-3 col-md-3">
                <div className="card w_card3">
                  <div
                    className="body w_summary knowCard"
                    style={{
                      backgroundColor: "#23252A",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      executeScroll("Critical");
                      setsearch("Critical");
                    }}
                  >
                    <div className="c_know mt-1 mr-3">
                      <Donut
                        className="knob"
                        diameter={45}
                        min={0}
                        max={100}
                        step={1}
                        value={totalCount?.Critical}
                        theme={{
                          donutThickness: 2,
                          donutColor: "#CA1D1D",
                          // centerColor: "transparent",
                          bgrColor: "#CA1D1D",
                        }}
                      />
                    </div>
                    <div className="s_detail">
                      <h4 className="mb-0">Critical</h4>
                      <span>Vulnerabilities</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-3">
                <div className="card w_card3">
                  <div
                    className="body w_summary knowCard"
                    style={{
                      backgroundColor: "#23252A",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      executeScroll("High");
                      setsearch("High");
                    }}
                  >
                    <div className="c_know mt-1 mr-3">
                      <Donut
                        className="knob"
                        diameter={45}
                        min={0}
                        max={100}
                        step={1}
                        value={totalCount?.High}
                        theme={{
                          donutThickness: 2,
                          donutColor: "#EE4B2B",
                          // centerColor: "transparent",
                          bgrColor: "#EE4B2B",
                        }}
                      />
                    </div>
                    <div className="s_detail">
                      <h4 className="mb-0">High</h4>
                      <span>Vulnerabilities</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-3">
                <div className="card w_card3">
                  <div
                    className="body w_summary knowCard"
                    style={{
                      backgroundColor: "#23252A",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      executeScroll("Medium");
                      setsearch("Medium");
                    }}
                  >
                    <div className="c_know mt-1 mr-3">
                      <Donut
                        className="knob"
                        diameter={45}
                        min={0}
                        max={100}
                        step={1}
                        value={totalCount?.Medium}
                        theme={{
                          donutThickness: 2,
                          donutColor: "#FF8C00",
                          // centerColor: "transparent",
                          bgrColor: "#FF8C00",
                        }}
                      />
                    </div>
                    <div className="s_detail">
                      <h4 className="mb-0">Medium</h4>
                      <span>Vulnerabilities</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-3">
                <div className="card w_card3">
                  <div
                    className="body w_summary knowCard"
                    style={{
                      backgroundColor: "#23252A",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      executeScroll("Low");
                      setsearch("Low");
                    }}
                  >
                    <div className="c_know mt-1 mr-3">
                      <Donut
                        className="knob"
                        diameter={45}
                        min={0}
                        max={100}
                        step={1}
                        value={totalCount?.Low}
                        theme={{
                          donutThickness: 2,
                          donutColor: "#48B461",
                          // centerColor: "transparent",
                          bgrColor: "#48B461",
                        }}
                      />
                    </div>
                    <div className="s_detail">
                      <h4 className="mb-0">Low</h4>
                      <span>Vulnerabilities</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row clearfix">
          <div className="col-lg-12 col-md-12">
            <div className="card">
              <div className="body">
                <div className="header" ref={myRef}>
                  <div className="row align-items-center">
                    <div className="col-sm-12" style={{ marginTop: "10px" }}>
                      <div className="d-flex justify-content-between align-items-center">
                        <h6>Vulnerability Details</h6>
                        <div className="filterBox">
                          <div className="searchBoxInput">
                            <input
                              type="text"
                              className="form-control"
                              onChange={handleSearchChange}
                              placeholder="Search"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="table-responsive invoice_list mb-4">
                        <table className="table table-custom spacing5 mb-0">
                          <thead>
                            <tr>
                              <th>Ip Address</th>
                              <th>CVE Vulnerabilities   <FontAwesomeIcon icon={faSortUp} style={{ marginLeft: '5px', cursor: 'pointer' }}
                                onClick={() => { setSortOrder('asc') }}
                              />
                                <FontAwesomeIcon icon={faSortDown} style={{ cursor: 'pointer' }}
                                  onClick={() => { setSortOrder('desc') }}
                                /></th>
                              <th>Exploits   <FontAwesomeIcon icon={faSortUp} style={{ marginLeft: '5px', cursor: 'pointer' }}
                                onClick={() => { setSortOrder('asc') }}
                              />
                                <FontAwesomeIcon icon={faSortDown} style={{ cursor: 'pointer' }}
                                  onClick={() => { setSortOrder('desc') }}
                                /></th>
                              <th>severity   <FontAwesomeIcon icon={faSortUp} style={{ marginLeft: '5px', cursor: 'pointer' }}
                                onClick={() => { setSortOrder('asc') }}
                              />
                                <FontAwesomeIcon icon={faSortDown} style={{ cursor: 'pointer' }}
                                  onClick={() => { setSortOrder('desc') }}
                                /></th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {currentTableData?.map((row) => {
                              return (
                                <tr>
                                  <td style={{ whiteSpace: "unset" }}>
                                    <Link to={`/active-va/details/${row?.ipAddress}/all`} style={{ textDecoration: 'underline' }}>{row?.ipAddress}</Link>
                                  </td>
                                  <td style={{ whiteSpace: "unset" }}>
                                    <span
                                      className={
                                        row?.risk === "Medium"
                                          ? "badge badge-med"
                                          : row?.risk === "Low"
                                            ? "badge badge-low"
                                            : row?.risk === "High"
                                              ? "badge badge-high"
                                              : row?.risk === "Critical"
                                                ? "badge badge-critical"
                                                : "N/A"
                                      }
                                    >
                                      {row?.totalCriticalRisk + row?.totalHighRisk + row?.totalMediumRisk + row?.totalLowRisk || 0} : Found
                                    </span>
                                  </td>
                                  <td style={{ whiteSpace: "unset" }}>
                                    {row?.exploits || 0} : Found
                                  </td>
                                  <td style={{ whiteSpace: "unset" }}>
                                    <div className="severity_box">
                                      <Link to={`/active-va/details/${row?.ipAddress}/Critical`} className="critical_P">
                                        <span>{row?.totalCriticalRisk || 0}</span>
                                        Critical
                                      </Link>
                                      <Link to={`/active-va/details/${row?.ipAddress}/High`} className="high_P">
                                        <span>{row?.totalHighRisk || 0}</span>
                                        High
                                      </Link>
                                      <Link to={`/active-va/details/${row?.ipAddress}/Medium`} className="medium_P">
                                        <span>{row?.totalMediumRisk || 0}</span>
                                        Medium
                                      </Link>
                                      <Link to={`/active-va/details/${row?.ipAddress}/Low`} className="low_P">
                                        <span>{row?.totalLowRisk || 0}</span>
                                        Low
                                      </Link>
                                    </div>
                                  </td>
                                  <td>
                                    {row?.scanStatus === "completed" ? (
                                      <button
                                        type="button"
                                        className="btn btn-primary mr-1"
                                        style={{ color: "black", fontWeight: "bold" }}
                                        onClick={() => {
                                          reScan(row?.ipAddress)
                                        }}
                                      >
                                        Rescan
                                      </button>
                                    ) : (
                                      <span>Scanning...</span>
                                    )}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                      <div className="dataTables_paginate">
                        {totalItems > 0 && (
                          <Pagination
                            className="pagination-bar"
                            currentPage={page}
                            totalCount={totalItems}
                            pageSize={10}
                            onPageChange={(page) => {
                              setPage(page);
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row clearfix"></div>
            </div>
          </div>
        </div>
        <div className="row clearfix"></div>
        <div
          className={`modal fade Form-Wizard-modal ${isModalThree === "Form Wizard modalThree" ? "d-block show" : ""
            }`}
        >
          <div className="modal-dialog modal-lg" id="clientModal">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Add IP Address
                </h5>
                <button
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setModalThree("");
                    setIps([]);
                  }}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body pricing_page">
                <div className="col-xl-12 col-lg-12 col-md-12">
                  <div className="card">
                    <div className="row clearfix">
                      <div className="col-md-12">
                        <div className="form-group d-flex">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="IP Address"
                            name="ips"
                            id="ips"
                            style={{ float: "left", width: "89%" }}
                          />
                          <button
                            type="button"
                            style={{ float: "left", marginLeft: '5px' }}
                            className="btn btn-primary"
                            onClick={() => addIps()}
                          >
                            <i
                              className="fa fa-plus"
                              style={{ fontSize: "22px", color: "black" }}
                            ></i>
                          </button>
                        </div>
                        {Ips && Ips.length > 0 && (
                          <div className="row">
                            <div className="col-md-12">
                              {Ips?.map((keyword, index) => {
                                return (
                                  <label
                                    key={index}
                                    style={{
                                      color: "white",
                                      background: "#43a5f5",
                                      padding: "4px 6px",
                                      margin: "5px 5px"
                                    }}
                                  >
                                    <span>
                                      {keyword}{" "}
                                      <span
                                        className="fa fa-times-circle"
                                        onClick={() =>
                                          removeKeyword(index)
                                        }
                                      ></span>
                                    </span>
                                  </label>
                                );
                              })}
                            </div>
                          </div>)}
                      </div>
                      <div className="col-md-12 text-center">
                        <button
                          type="button"
                          style={{ color: "black", fontWeight: "bold" }}
                          className="btn btn-round btn-primary mr-1"
                          onClick={() => {
                            submitIps()
                          }}
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className={`modal fade Form-Wizard-modal ${isModalThree === "Form Wizard modalThree" ? "d-block show" : ""
            }`}
        >
          <div className="modal-dialog modal-lg" id="clientModal">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Add IP Address
                </h5>
                <button
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setModalThree("");
                    setIps([]);
                  }}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body pricing_page">
                <div className="col-xl-12 col-lg-12 col-md-12">
                  <div className="card">
                    <div className="row clearfix">
                      <div className="col-md-12">
                        <div className="form-group d-flex">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="IP Address"
                            name="ips"
                            id="ips"
                            style={{ float: "left", width: "89%" }}
                          />
                          <button
                            type="button"
                            style={{ float: "left", marginLeft: '5px' }}
                            className="btn btn-primary"
                            onClick={() => addIps()}
                          >
                            <i
                              className="fa fa-plus"
                              style={{ fontSize: "22px", color: "black" }}
                            ></i>
                          </button>
                        </div>
                        {Ips && Ips.length > 0 && (
                          <div className="row">
                            <div className="col-md-12">
                              {Ips?.map((keyword, index) => {
                                return (
                                  <label
                                    key={index}
                                    style={{
                                      color: "white",
                                      background: "#43a5f5",
                                      padding: "4px 6px",
                                      margin: "5px 5px"
                                    }}
                                  >
                                    <span>
                                      {keyword}{" "}
                                      <span
                                        className="fa fa-times-circle"
                                        onClick={() =>
                                          removeKeyword(index)
                                        }
                                      ></span>
                                    </span>
                                  </label>
                                );
                              })}
                            </div>
                          </div>)}
                      </div>
                      <div className="col-md-12 text-center">
                        <button
                          type="button"
                          style={{ color: "black", fontWeight: "bold" }}
                          className="btn btn-round btn-primary mr-1"
                          onClick={() => {
                            submitIps()
                          }}
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InfrastructureVA;